import { Content } from '@/components/planos_municipais';

export default function PlanosMunicipais() {
  return ( <Content /> );
}
